import { observer } from 'mobx-react-lite'
import { useTranslationTyped } from 'i18n/i18n'
import { PeerReviewMeaningOfScores } from 'components/PeerReview/PeerReviewMeaningOfScores'
import { BreakoutButton } from 'components/design-system/BreakoutButton'
import classNames from 'classnames'
import { FlagIcon } from 'components/icons/FlagIcon'
import { ChevronRight } from 'components/icons/ChevronRight'

export const PeerReviewInstructionsTab = observer(
  function PeerReviewInstructionsTab({
    className,
    peerReviewQuestions,
    setSelectedTab,
  }: {
    className?: string
    peerReviewQuestions: Array<{
      id: string
      data: { prQuestion: string; prDescription: string; prOrder: number }
    }>
    setSelectedTab: (tab: 'instructions' | 'feedbackForm') => void
  }) {
    const { tt } = useTranslationTyped()

    return (
      <div className={classNames('flex flex-1 flex-col gap-3', className)}>
        <p className="text-body-medium text-on-surface-var">
          {tt.student_assignment.peer_review_dialog.instructions_text()}
        </p>
        <div className="flex flex-1 gap-10">
          <div className="flex w-1/2 flex-1 flex-col gap-2">
            <h3 className="text-title-medium text-on-surface">
              {tt.student_assignment.peer_review_dialog.criteria()}
            </h3>
            {peerReviewQuestions.map((question) => (
              <div
                key={question.id}
                data-testid="peer-review-criterion"
                className="rounded-xl bg-surface-light px-4 py-2"
              >
                <div className="flex flex-col gap-2">
                  <h4
                    data-testid="peer-review-criterion-name"
                    className="text-title-small text-on-surface"
                  >
                    {question.data.prQuestion}
                  </h4>
                  <p
                    data-testid="peer-review-criterion-description"
                    className="text-body-medium text-on-surface-var"
                  >
                    {question.data.prDescription}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div className="flex w-1/2 flex-col">
            <PeerReviewMeaningOfScores />
            {/* TODO: Replace this with BreakoutAlert if we standardize this lighter variant of a warning alert? */}
            <div
              className={classNames(
                'flex items-center gap-2 rounded-lg border px-3 py-2',
                'border-fixed-accent-color bg-fixed-eggshell',
                'mt-3'
              )}
            >
              <FlagIcon />
              <div className="flex-1 text-body-medium">
                {tt.student_assignment.peer_review_dialog.note_visibility()}
              </div>
            </div>
            {/* <BreakoutAlert variant="warning" className="mt-3">
              {tt.student_assignment.peer_review_dialog.note_visibility()}
            </BreakoutAlert> */}
            <div className="mt-4 flex flex-1 flex-col items-end justify-end">
              <BreakoutButton
                data-testid="peer-review-start-button"
                kind="accent"
                iconOnRight
                icon={<ChevronRight size={16} />}
                onClick={() => {
                  setSelectedTab('feedbackForm')
                }}
              >
                {tt.student_assignment.peer_review_dialog.start_peer_review()}
              </BreakoutButton>
            </div>
          </div>
        </div>
      </div>
    )
  }
)
